import { render, staticRenderFns } from "./ProfileSellRequestsTab.vue?vue&type=template&id=5844aca2&scoped=true"
import script from "./ProfileSellRequestsTab.vue?vue&type=script&lang=js"
export * from "./ProfileSellRequestsTab.vue?vue&type=script&lang=js"
import style0 from "./ProfileSellRequestsTab.vue?vue&type=style&index=0&id=5844aca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844aca2",
  null
  
)

export default component.exports